import { type FC, useCallback } from 'react';

import { useHoveredOfferActionsContext } from '@/app/shared/context/HoveredOfferContext';
import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { listingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';
import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';

import { CardLayout } from '../../../components/CardLayout';
import { useCardContext } from '../../../context/CardContext';
import { useCardOfferContext } from '../../../context/selectors';
import { useCardClickAction } from '../../../hooks/card/useCardClickAction';

import { ContentContainer } from './ContentContainer';
import { GalleryContainer } from './GalleryContainer';
import { PublisherContainer } from './PublisherContainer';

export const CardLayoutContainer: FC = () => {
  const offer = useCardOfferContext();

  const { index } = useCardContext();

  const {
    data: {
      extendedProperties: { offerServices },
    },
  } = offer;

  const { onOfferHover, onOfferBlur } = useHoveredOfferActionsContext();

  const activePinId = useActivePinIdSelector();
  const reduxState = useReduxState();

  const handleCardClick = useCardClickAction();

  const handleCardMouseEnter = useCallback(() => {
    const isNarrow = listingLayoutIsNarrowSelector(reduxState.getState());

    if (!isNarrow || Boolean(activePinId)) {
      return;
    }

    onOfferHover(offer);
  }, [activePinId, offer, reduxState, onOfferHover]);

  return (
    <CardLayout
      content={<ContentContainer />}
      data-testid={`card-item.${index}`}
      gallery={<GalleryContainer />}
      isTop={offerServices?.isTop3}
      publisher={<PublisherContainer />}
      onClick={handleCardClick}
      onMouseEnter={handleCardMouseEnter}
      onMouseLeave={onOfferBlur}
    />
  );
};
